export const ORDER_DETAILS_PAGE_SIZE = 20

export const ORDER_DETAILS_API_URL = '/picking-service/v3/orderDetails'
